<template>
<div>
    <div class="penpart" v-if="init">

        <div :class="{'actived':actived==='init'}" @click="penactived('init')" v-if="!careflag"><i class="iconfont icon-normal_cut"></i><span>涂抹</span></div>
        <div class="sec_lc" @click="tocare" v-if="!careflag"><i class="iconfont icon-careful_cut"></i><span>精细抠图</span></div>
        <div class="sec_lc" :class="{'actived':actived==='del'}" @click="penactived('del')" v-if="careflag"><i class="iconfont icon-del"></i><span>剔除</span></div>
        <div class="sec_lc" :class="{'actived':actived==='save'}" @click="penactived('save')" v-if="careflag"><i class="iconfont icon-save"></i><span>保留</span></div>
        <div class="sec_lc" :class="{'actived':actived==='eraser'}" @click="penactived('eraser')" v-if="careflag"><i class="iconfont icon-eraser"></i><span>橡皮擦</span></div>
        <div class="sec_lc" :class="{'actived':actived==='repair'}" @click="penactived('repair')" v-if="careflag"><i class="iconfont icon-repair"></i><span>修复擦</span></div>
        <div class="penwidth">
            <label>笔刷大小</label>
            <el-slider v-model="value" :disabled="!init" :show-tooltip="false"></el-slider>
            <span >{{penwidth}}px</span>
        </div>
        <div class="change-bck-bar">
            <span>预览色</span>
            <div @click="changeback(0)">
                <img src="../assets/image/penpart/chose.png" v-if="backStyle==0" />
            </div>
            <div @click="changeback(1)">
                <img src="../assets/image/penpart/chose.png" v-if="backStyle==1" />
            </div>
            <div @click="changeback(2)">
                <img src="../assets/image/penpart/chose.png" v-if="backStyle==2" />
            </div>
            <div @click="changeback(3)">
                <img src="../assets/image/penpart/chose.png" v-if="backStyle==3" />
            </div>
        </div>
    </div>
</div>
</template>

<script>
export default {
    data() {
        return {
            backStyle:0,
            init: false,
            actived: 'init',
            value: 66,
            penwidth: 100,
            careflag: false
        }
    },
    methods: {
        changeback(index){
              this.backStyle=index;
              this.$emit('changeback',index)
        },
        reupload() {
            Object.assign(this.$data, this.$options.data())
        },
        tocare() {
            this.$emit("tocare")
        },
        hasmark(flag) {
            if (flag) {
                this.careflag = true;
                this.actived = 'del';
                this.value = 20;
            } else {
                this.$emit("opennormalhelp")
            }
        },
        firstinit() {
            this.init = true;
        },
        toolactived() {
            this.actived = '';
        },
        penactived(type) {
            this.actived = type;
            this.$emit("penactived", type);
        }
    },
    watch: {
        value(val) {
            if (val != 66) {
                if (parseInt((this.value / 100) * 150) < 1) {
                    this.penwidth = 1;
                    this.$emit('sizechange', 1)
                } else {
                    this.penwidth = parseInt((this.value / 100) * 150);
                    this.$emit('sizechange', parseInt((this.value / 100) * 150))
                }
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.change-bck-bar{
    margin-left: 12px;
    width: 270px !important;
    cursor: default !important;
    img{
        padding-top: 11px;
    }
    >div{
        cursor: pointer;
        border-radius: 2px;
        border: 1px solid #ccc;
        width: 32px;
        height: 32px;
        background: #000;
        margin-left: 12px;
        &:nth-child(2){
            background: url('../assets/image/penpart/transparent.png')
        }
        &:nth-child(3){
            background: #fff
        }
         &:nth-child(5){
            background: #ccc
        }
    }
}
.penpart {
    position: fixed;
    bottom: 20px;
    display: flex;
    left: 50%;
    transform: translate(-50%);
    justify-content: center;
    z-index: 997;

    >div {
        justify-content: center;
        font-size: 14px;
        text-align: center;
        height: 60px;
        background: #fff;
        color: #444;
        cursor: pointer;
        display: flex;
        line-height: 20px;
        align-items: center;
        width: 126px;

        i {

            font-size: 20px;
            margin-right: 8px
        }
    }

    .sec_lc {
        margin-left: 2px
    }

    .sec_lc:hover {
        background: #0763fc;
        color: #fff
    }

    .actived {
        background: #0763fc;
        color: #fff
    }

    .penwidth {
        margin-left: 12px;
         width: 287px;
        label {
            margin-right: 17px;
        }

        >div {
            width: 102px;
        }

        span {
            margin-left: 17px;
            width: 39px
        }
    }

}
</style>
